<template>
  <div id="idle-alert-modal">
    <!-- modal for idle user -->
    <v-dialog
        persistent
        v-model="idle.dialog"
        max-width="500px"
        overlay-opacity="0.90"
      >
        <v-card>
          <v-card-text class="pt-5 text-center">
            You have been inactive for a while are you still here?
          </v-card-text>
          <div class="text-center pb-5">
            <v-btn rounded color="deep-orange accent-2" dark dense @click="pollData()">I'm back</v-btn>
          </div>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["idle"]),
  methods: {
    pollData() {
      this.$store.dispatch("hideIdleDialog");
      this.$emit("resumePolling")
    }
  },
}
</script>